/**
 * Client-facing branding.
 *
 * MERCURY_FAIRWAY is the internal factory name (repo, docs, vault). What the
 * golfer sees is the client's brand. Same precedent as Aussie Automations:
 * never rename the factory, brand the output.
 *
 * Override per build:
 *   VITE_BRAND_NAME="GoCaddy" VITE_BRAND_ACCENT="#38e07b" npm run build
 *   (omit VITE_BRAND_ACCENT for the default monochrome chrome)
 */
export const BRAND = {
  name: import.meta.env.VITE_BRAND_NAME ?? 'GoCaddy',
  tagline: import.meta.env.VITE_BRAND_TAGLINE ?? 'Every course. Every yard.',
  /** Empty = monochrome chrome from styles.css, which themes light/dark. */
  accent: import.meta.env.VITE_BRAND_ACCENT ?? '',
  /** Shown in Setup so a support call can identify the exact build on a unit. */
  build: import.meta.env.VITE_BUILD_ID ?? 'dev',
};

/** Applied once at boot so a rebrand is a build flag, not a CSS edit. */
export function applyBrand() {
  // 🟥 Only for a client who supplies a brand colour. An inline custom property
  // beats every stylesheet rule, so setting this unconditionally would pin the
  // accent in BOTH themes and silently break light mode's black-on-white.
  if (BRAND.accent) {
    document.documentElement.style.setProperty('--accent', BRAND.accent);
  }
  document.title = BRAND.name;
}
